import React, { Fragment } from "react";
import _ from "lodash";

import { TableExpandableCard } from "../../../../../../../components/table/components/TableExpandableCard";
import { DeviceNameCellMobile } from "../../../../../../../components/table";
import { DeviceWithType } from "../../../../../../../components/devices/DeviceWithType";
import { ProfileDevicesDropdownActions } from "../profileDevicesDropdownActions";

export const TableCard = ({ name, details, identifiers, profile }) => {
  return (
    <TableExpandableCard
      showExpand={false}
      content={
        <Fragment>
          <DeviceNameCellMobile name={name} />
          <div className={"identifiers-block"}>
            {_.map(details, ({ type, identifier }) => (
              <DeviceWithType
                key={identifier}
                type={type}
                identifier={identifier}
              />
            ))}
          </div>
        </Fragment>
      }
      aside={
        <ProfileDevicesDropdownActions
          identifiers={identifiers}
          deviceDetails={details}
          name={name}
          profile={profile}
        />
      }
    />
  );
};
